import type { CylinderShape } from './cylinder-params';

export interface CurveBounds {
  readonly top: number;
  readonly bottom: number;
}

/**
 * 투영 영역의 가로 비율 c(0~1) 열에서 위·아래 경계의 캔버스 y.
 * 타원 높이 비율 e = √(1 − (1 − 2c)²) 는 출력 좌표 기준이다(Phase 0 판정 후보 1).
 * 가운데(e = 1)는 area 위·아래 끝이고, 양 끝(e = 0)은 upSide·downSide 만큼 움직인다.
 */
export function curveBounds(c: number, params: CylinderShape): CurveBounds {
  return curveBoundsFromRatio(2 * Math.sqrt(Math.max(0, c * (1 - c))), params);
}

/** 타원 높이 비율 e(0~1)로 위·아래 경계의 캔버스 y 를 구한다. e 를 더 정밀하게 아는 호출자가 쓴다. */
export function curveBoundsFromRatio(e: number, params: CylinderShape): CurveBounds {
  const { area, upSide, downSide } = params;
  return {
    top: area.top + upSide * (1 - e),
    bottom: area.top + area.height + downSide * (1 - e),
  };
}

/**
 * 투영 영역의 열 c 에서 출력 y 를 원본 y 로 되돌린다(마플 `makeY` 대응).
 * 그 열의 위·아래 경계 사이를 원본 area 높이에 선형으로 맞춘다.
 * 경계 밖·맞닿은 열을 거르지 않는 저수준 식이다. 점 단위로는 warpedToSource 를 쓴다.
 */
export function makeY(c: number, warpedY: number, params: CylinderShape): number {
  const { top, bottom } = curveBounds(c, params);
  return params.area.top + ((warpedY - top) * params.area.height) / (bottom - top);
}
